import { createContext } from "react";
import { ReferrerContextValues } from "./types";

export const initialReferrerContextState = {
  goBackTextId: "",
} as ReferrerContextValues;
export const ReferrerContext = createContext(initialReferrerContextState);
